import { FaTimes, FaBars } from 'react-icons/fa'
import { PiArrowLeftBold } from 'react-icons/pi'

import { useMenuState } from 'src/providers/MenuStateProvider'

import { IconButton } from 'src/components/atoms/IconButton'
import { InternalLink } from 'src/components/atoms/Link'
import { LogoRebrand } from 'src/components/atoms/LogoRebrand'

import { homePath } from 'src/config/paths'
import { NavigationContext } from 'src/types/account'

export const MobileNavigationToggle = ({
  navigationContext,
  showReturnLink = false
}: {
  navigationContext: NavigationContext
  showReturnLink?: boolean
}) => {
  const { isOpen, setIsOpen } = useMenuState()

  const handleSetIsOpen = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div className='mx-5 grow min-w-0 justify-between items-start px-3 visible flex lg:hidden'>
      <div className='flex flex-col min-w-0'>
        <InternalLink href={homePath}>
          <LogoRebrand
            className={`link h-10 w-auto max-w-full ${
              navigationContext === NavigationContext.Public
                ? 'text-forestDeep'
                : 'text-white'
            }`}
          />
        </InternalLink>
        {showReturnLink && (
          <div className='flex items-center py-4 px-2'>
            <PiArrowLeftBold className='mr-2 shrink-0 text-white' />
            <InternalLink
              color='none'
              className='font-normal! text-sm text-white underline hover:no-underline'
              href='/'
            >
              Return to the website
            </InternalLink>
          </div>
        )}
      </div>
      <div className='flex space-x-1 items-center'>
        <IconButton
          icon={isOpen ? FaTimes : FaBars}
          ariaLabel={isOpen ? 'Close menu' : 'Open menu'}
          className={`link ${
            navigationContext !== NavigationContext.Public
              ? 'text-white'
              : 'text-forestDeep'
          }`}
          onClick={handleSetIsOpen}
          size='small'
        />
      </div>
    </div>
  )
}
